import { render, staticRenderFns } from "./TableSupports.vue?vue&type=template&id=3c254b1c&"
import script from "./TableSupports.vue?vue&type=script&lang=js&"
export * from "./TableSupports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports